import { Component, ElementRef, OnInit, signal } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Blog } from '../../../../models/blog';
import { Category } from '../../../../models/category';
import { FormControl } from '@angular/forms';

import { MessageService, SelectItem } from "primeng/api";
import moment from 'moment';
import { Comuni } from 'src/app/models/comuni';
import { STATE_LIST } from 'src/app/admin/constants/constants';
import { FeaturesPersonsService } from 'src/app/services/features_persons.service';
import { FeaturesTypologysService } from 'src/app/services/features_typologyy';
import { TagsService } from 'src/app/services/tags.service';
import { TechnologyService } from 'src/app/services/technology.service';

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { ReactiveFormsModule } from "@angular/forms";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";

@Component({
    selector: 'app-technology-form',
    templateUrl: './technology-form.component.html',
    imports: [ButtonModule, CardModule, FormsModule, InputTextModule, ReactiveFormsModule, Ripple, RouterLink]
})
export class TechnologyFormComponent implements OnInit {
  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;

  pageTitle = signal("");
  error = signal<any>(null);
  uploadError = signal<string>("");
  imagePath: any;
  categories: Category;
  category: Category;

  comuni: Comuni;

  checked: boolean = true;
  selectedValue: string;

  categoryForm: UntypedFormGroup;

  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedCategories: Category;
  selectedDate: Date;
  date: Date;
  currentUser: any;
  stateOptions: any[];

  constructor(
    private fb: UntypedFormBuilder,
    private technologyService: TechnologyService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (this.date) {
      this.selectedDate = new Date(this.date);
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '[]');
  }

  ngOnInit() {


    const id = this.route.snapshot.paramMap.get('id');
    this.stateOptions = STATE_LIST;

    if (id) {


      this.pageTitle.set('Modifica');
      this.technologyService.getId(+id).subscribe(
        res => {
          this.categoryForm.patchValue({
            title: res.title,
            description: res.description,
            id: res.id
          });

        }
      );
    } else {
      this.pageTitle.set('Aggiungi');
    }

    this.categoryForm = this.fb.group({
      id: [''],
      title: ['', Validators.required],
      description: [''],

    });
  }


  get category_name() {
    return this.categoryForm.get('name');

  }


  onSubmit() {

    const formData = new FormData();

    formData.append('title', this.categoryForm.get('title').value);
    formData.append('description', this.categoryForm.get('description').value);

    const id = this.categoryForm.get('id').value;

    if (id) {
      this.technologyService.update(formData, +id).subscribe({ next: (res: any) => {
          if (res.status == 'error') {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
            this.router.navigate(['/admin/settings/features-typology']);
          }
        }, error: (error: any) => this.error.set(error) });
    } else {
      this.technologyService.create(formData).subscribe({ next: (res: any) => {
          if (res.status === 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/settings/features-typology']);
          }
        }, error: (error: any) => this.error.set(error) });
    }

  }

}
